import React from "react";
import CopyToClipboard from "components/CopyToClipboard";
import Token from "components/Token";
const DEFAULT_CLASSES = {
  container: "flex flex-column w-100",
  label: "field__label fw5 db",
  content: "flex flex-row items-center",
  value:
    "token-monospace f5 lh-copy word-break-all pa2 bg-content--secondary ba br2 hairline-1 w-100"
};

const CopyCode = ({ label, customClasses, value, tooltip, toast, onClick }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };

  return (
    <div className={classes.container}>
      {label && <label className={classes.label}>{label}</label>}
      <div className={classes.content}>
        <CopyToClipboard
          tooltip={tooltip}
          toast={toast}
          value={value}
          onClick={onClick}
        />
        <Token
          value={value}
          customClasses={{
            container: classes.value
          }}
        />
      </div>
    </div>
  );
};

export default CopyCode;
